export const camelToSnakeCase = (value?: string): string => {
    return (
        value?.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`) ?? ""
    );
};

export const snakeToSentenceCase = (value?: string): string => {
    const words = value?.replace(/_/g, " ").trim() ?? "";
    return words.charAt(0).toUpperCase() + words.slice(1);
};

export const snakeToCamelCase = (value?: string): string => {
    return (
        value?.replace(/(_\w)/g, (matches) => matches[1].toUpperCase()) ?? ""
    );
};
